module.exports = __webpack_public_path__ + "static/media/27-8.f25e7170.mp3";